import React, { useMemo } from 'react'
import GenericPullConfigListing from '../GenericPullConfigListing'
import SnykCredentialsForm from './SnykCredentialsForm'
import SnykMappingFormV2 from './SnykMappingFormV2';
import SnykMappingFormNew from './SnykMappingFormNew';
import { CellRenderers } from 'utils/tableUtils';
import _, { isEmpty, compact } from 'lodash';
import ContentOverlay from 'components/ContentOverlay';
import { Typography } from 'antd';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
const {Link} = Typography;
const DELIMITER = ';'
const REFERENCE_DELIMITER = "|";
export default function SnykConfigListing(props) {
    const featureFlags = useFeatureFlag();

    const columns = useMemo(() => [
    ...(featureFlags.SNYK_PROJECTS_BY_TARGET ? [{
        title: "Target",
        dataIndex: "projectName",
        width: 200,
        render: (targetId, record) => renderTargetName(record, props,featureFlags.SNYK_TARGET_ORIGIN)
    }] : []),
    {
        title: "Project",
        dataIndex: featureFlags.SNYK_PROJECTS_BY_TARGET ? "project" : "projectName",
        width: 240,
        render: (projectName, record) => featureFlags.SNYK_PROJECTS_BY_TARGET ? renderTargetProjectNames(record, props) : renderProjectNames(projectName, record, props,featureFlags.SNYK_TARGET_ORIGIN),
        showFilter: !featureFlags.SNYK_PROJECTS_BY_TARGET
    },
    {
        title: "Type",
        dataIndex: "project_type",
        width: 150,
        render: type => (type && type === 'collections') ? 'Collection' : 'Project',
        showFilter: false
    },
    {
        title: "Scan Type",
        dataIndex: "scanType",
        width: 150,
        render: (scanType, record) => CellRenderers.TAGS(isEmpty(scanType) ? [] : scanType.split(',')),
    }], [props, featureFlags.SNYK_PROJECTS_BY_TARGET,featureFlags.SNYK_TARGET_ORIGIN]);

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={featureFlags.SNYK_PROJECTS_BY_TARGET ? SnykMappingFormNew : SnykMappingFormV2}
            CredentialsForm={SnykCredentialsForm}
            triggerModifyParam={triggerModifyParam}
            extraColumns={columns}
            showOrganisationColumn={true}
        />
    )
};

const triggerModifyParam = (record) => {
    return {
        toolConfigId: record.id
    }
};

const renderTargetProjectNames = (record, props) => {
    let projectName = record.projectName;
    const projectNames = _.split(projectName, ",");
    const projects = _.map(projectNames, (targetProject) => {
        const index = targetProject.indexOf(DELIMITER);
        const projectIndex = targetProject.indexOf(REFERENCE_DELIMITER);

        let target;
        let references;
        let project;
        if (index === -1) {
          target = targetProject.substring(0, projectIndex) || targetProject;
        }
        if (index !== -1) {
          target = targetProject.substring(0, index);
          references = targetProject.substring(
            index + 1,
            targetProject.substring(
              0,
              projectIndex !== -1 ? projectIndex : targetProject.length
            ).length
          );
        }
        if (projectIndex !== -1) {
          project = targetProject.substring(
            projectIndex + 1,
            targetProject.length
          );
        }

        return {
            project: _.split(project, "|"),
            target,
            references: !isEmpty(references)
            ? _.split(references.replace(/;/g, ","), ",")
            : [], 
        }
    });

    const content = _.map(projects, (project) => {
        if(!isEmpty(compact(project.project))){
            return project.project.map(p => {
                const reference = !isEmpty(project.references) ? `- [${project.references.join(", ")}]` : ""
                let item = `${p} ${reference}`;
                return (
                <p>
                    <Link
                        href={`/user/tools/generic/project/${props.name}/redirect?login_id=${record.login_id}&orgId=${record.orgId}&name=${encodeURIComponent(project.target)}`}
                        className='m-b-xs'
                        target='_blank'
                    >
                        {item}
                    </Link>
                </p>)
            })
        } else {
            return <p>{!isEmpty(project.references) ? `[${project.references.join(", ")}]` : CellRenderers.VALUE_OR_NA()}</p>
        };
    });

    return <ContentOverlay content={content} minHeight={40}/>
};

const renderTargetName = (record, props,featureFlag_SNYK_TARGET_ORIGIN) => {
    const projectNames = _.split(record.projectName, ",");
    const originNames = record?.origin?_.split(record?.origin, ","):[];
    const projects = _.map(projectNames, (targetProject,i) => {
        const index = targetProject.indexOf(DELIMITER);
        const projectIndex = targetProject.indexOf(REFERENCE_DELIMITER);

        let target;
        if (index === -1) {
          target = targetProject.substring(0, projectIndex) || targetProject;
        }
        if (index !== -1) {
          target = targetProject.substring(0, index);
        }
        return { target:((featureFlag_SNYK_TARGET_ORIGIN&&originNames[i])?`[${originNames[i]}] `:'')+target }
    });

    const content = _.map(projects, (project) =>( 
        <p>
            <Link
                href={`/user/tools/generic/project/${props.name}/redirect?login_id=${record.login_id}&orgId=${record.orgId}&name=${encodeURIComponent(project.target)}`}
                className='m-b-xs'
                target='_blank'
            >
                {project.target}
            </Link>
        </p>
    ))
    return <ContentOverlay content={content} minHeight={40}/>
}
const renderProjectNames = (projectName, record, props,featureFlag_SNYK_TARGET_ORIGIN) => {
    const projectNames = _.split(projectName, ",");
    const originNames = record?.origin ? _.split(record?.origin,",") : [];
    const projectArr = [];
    _.forEach(projectNames, (project, i) => {
        const index = project.indexOf(DELIMITER);
        const _project = project.substring(0, index === -1 ? undefined : index);

        projectArr.push({
            p: _project,
            org: originNames[i]
        }) 

        if(index !== -1){
          const references = project.substring(index + 1, project.length);
          projectArr[i].ref = _.split(references.replace(/;/g, ','), ',')
        }
    })

    const renderName = projectArr.map(item => ((featureFlag_SNYK_TARGET_ORIGIN && item.org )?`[${item.org}] `:'')+(item.ref ? `${item.p} - [${item.ref}]` : `${item.p}`) )
    const projectType = record?.project_type || '';
    const content = renderName.map(item => 
            {
            const index = item.indexOf(' - [');
            const itemName = item.substring(0, index === -1 ? undefined : index);
            const [finalItemName] = itemName.split(";");// versions are appended after semi-colon
            return (
                <p>
                    <Link
                        href={`/user/tools/generic/project/${props.name}/redirect?login_id=${record.login_id}&orgId=${record.orgId}&name=${encodeURIComponent(finalItemName)}&projectType=${projectType}`}
                        className='m-b-xs'
                        target='_blank'
                    >
                        {item}
                    </Link>
                </p>
            );
        })

    return <ContentOverlay content={content} minHeight={40}/>
}